/* // globals caches, Promise */
(function($) {
	'use strict';
	$.fn.Collection__Download = function() {
		this.each(function() {

			/*
			 * Action: Download Collection
			 */
			var $self = $(this),
				collection_id = $self.data('cid');

			$self.off( $.Globals.clickEvent ).on( $.Globals.clickEvent, function(e) {
				e.preventDefault();


				// Sets listeners on $self
				var complete_message = $self.hasClass('downloaded') ? Front.translations.collection_nolonger_downloaded : Front.translations.collection_downloaded;
				// $.Globals.overlayNotify( $self, Front.translations.saving, complete_message );


				// ****************************************************
				// Setup download status percentage
				// ****************************************************
				// Vars
	      var $overlay = $('#overlay-white'),
	        $confirmation = $('#action-confirmation');

	      // Change message to saving and animate it in
	      $confirmation.find('.message').empty().html(Front.translations.saving + '... <span id="percent">0%</span>');
	      $overlay.addClass('show-notification');


				// Download status
				var $percent = $confirmation.find('#percent'),
					percent = 0;

				// Note: this is a catch for if the download does not ever return percentage === 1 (line 65 below)
				// If this gets used, we may need to add a log
				var catch_fails = setTimeout( () => {
		      $confirmation.find('.message').empty().html(Front.translations.saving + '... <span id="percent">Error.</span>');
				}, 10 * 1000 ); //<= if not loaded in 10 seconds show Error


				// Listen for downloads
				$.Window.on('scspaces-sw-dl-part', function(event) {

					// Don't run if already run with this percent
					// console.log({
					// 	percent: percent,
					// 	event: event.detail.percent,
					// })
					var tmp = parseFloat( (event.detail.current/event.detail.total).toFixed(2) );
					if( percent === tmp ) return;
					
					percent = tmp;
					$percent.html(( percent * 100 ) + '%');
					console.log(' ================= <= partial download = ' + ( percent * 100 ) + '%');

					// Done with download
					if( percent === 1 ) {

						clearTimeout( catch_fails ); // <= stop waiting for failure
		        setTimeout(function() {

		          // Hide notification
		          $overlay.removeClass('show-notification');

		          // After they are hidden
		          setTimeout(function() {

		            // change message to complete and slide it back in
		            $confirmation.find('.message').empty().html(complete_message);
		            $overlay.addClass('show-notification');

		            // Wait for a spec length of time
		            setTimeout(function() {

		              $overlay.removeClass('show-notification');

		            }, 1250);

		          }, $.Globals.fxSpeed);

		        }, 1000);
					}
				});



				// ****************************************************
				// Actually run the action
				// ****************************************************
				$.Globals.ajax('scspaces_collection__add_remove_from_downloads', { cid: collection_id }, function( response ) {
					if( response.success ) {

						var collection_edit_html, $tmp;
						if( response.data.action === 'added' ) {
							$self.addClass('downloaded').html( Front.translations.delete_from_downloads );

							// Update JS template if reopening collection Edit
							collection_edit_html = $('#collection--edit').html();
							$tmp = $( '<div></div>' );
							$tmp.html(collection_edit_html);
							$tmp.find('[data-controller="Collection__Download"]').addClass('downloaded').html( Front.translations.delete_from_downloads );
							$('#collection--edit').html( $tmp.html() );

						}else if( response.data.action === 'removed' ) {
							$self.removeClass('downloaded').html( Front.translations.download_collection );

							// Update template
							collection_edit_html = $('#collection--edit').html();
							$tmp = $( '<div></div>' );
							$tmp.html(collection_edit_html);
							$tmp.find('[data-controller="Collection__Download"]').removeClass('downloaded').html( Front.translations.download_collection );
							$('#collection--edit').html( $tmp.html() );
						}

						// V3
						// Register a new service Worker
						var offline_key = response.data.cache_name; // <= receive offline_key with offline_pre already
						spaces_register_sw( offline_key );


					} else {
						console.warn( 'AJAX Error: Adding / removing from downloads.' );
					}


					// Listen for complete to close overlay then trigger success message
					$self.trigger('overlay-notify-success');


				});

			});

		});
		return this;
	};
}(jQuery));
